module.exports = __webpack_public_path__ + "search2.png?7c03e39c13a235653d87a6b79f141490";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search2.png
// module id = 71
// module chunks = 0